import { motion } from "framer-motion";

const STEPS = [
  { n: "01", t: "Rencontre", d: "Échange téléphonique puis visite technique gratuite (1h30) chez vous. Nous écoutons, mesurons, photographions." },
  { n: "02", t: "Avant-projet", d: "Sous 10 jours, plans, axonométries et premier budget détaillé. Trois options sont systématiquement explorées." },
  { n: "03", t: "Dossier d'exécution", d: "Matériauthèque, planches matières, échantillons posés sur place, plans EXE techniques, planning prévisionnel." },
  { n: "04", t: "Chantier", d: "Démolition, gros œuvre, second œuvre, finitions. Un chef de projet unique, des points hebdomadaires, accès chantier sécurisé." },
  { n: "05", t: "Réception", d: "Visite de réception en présence de l'architecte. Levée des réserves sous 30 jours. Garanties activées." },
  { n: "06", t: "Suivi", d: "Service parfait achèvement durant un an, décennale durant dix ans. Nous restons à votre écoute." },
];

const PROCESS_IMG = "https://static.prod-images.emergentagent.com/jobs/389db444-e3c2-4bcc-82f1-4e5bf1ac1d53/images/7c19de0f2ecfe35dd80f994507c238d406e9bef9dc9c9476d387cec358bff232.png";

export default function Process() {
  return (
    <section id="methode" data-testid="process-section" className="section bg-bone">
      <div className="container-max">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-4">
            <p className="overline">— Méthode</p>
            <h2 className="font-display font-light text-5xl md:text-6xl leading-[0.95] tracking-tighter mt-6">
              Six étapes, <em className="italic text-terracotta">aucune approximation.</em>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-7">
            <img src={PROCESS_IMG} alt="Étude architecturale et plans" className="w-full aspect-[4/3] object-cover" loading="lazy" />
          </div>
        </div>

        <div className="border-t border-ink/20">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="grid grid-cols-12 gap-8 py-10 border-b border-ink/20 group hover:bg-ivory/40 transition-colors px-2"
              data-testid={`process-step-${s.n}`}
            >
              <div className="col-span-3 md:col-span-1 font-display text-4xl md:text-5xl text-terracotta">{s.n}</div>
              <h3 className="col-span-9 md:col-span-3 font-display text-3xl">{s.t}</h3>
              <p className="col-span-12 md:col-span-7 md:col-start-6 text-ink/75 text-lg leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
